<!--
 * @Author: zhangyu
 * @Date: 2021-12-22 11:13:43
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-08-22 20:08:33
 * @Description: 备件领用详情
-->
<template>
  <div class="home_page">
    <div class="spare_detail_page">
      <!-- 面包屑组件 -->
      <Breadcrumb :pageTitle="pageTitle" />
      <div class="page_detail" style="margin-bottom: 20px; display: flex">
        <div class="leftInfo">
          <h2>
            {{ $t("route.requisitionOrderDetail") }} ( {{ detailInfo.status }} )
          </h2>
          <el-form label-width="130px" label-position="right">
            <el-form-item :label="`${$t('stockNeed.requestNo')}:`">
              <Copyable :text="detailInfo.orderCode" />
            </el-form-item>
            <el-form-item :label="`${$t('stockNeed.requestTime')}:`">
              {{ detailInfo.createTime }}
            </el-form-item>
          </el-form>
          <div
            style="margin-top: 10px; margin-left: 53px"
            v-if="detailInfo.status === $t('stockNeed.tabs2')"
          >
            <el-button
              type="done"
              @click="openDetailUpdate(detailInfo.orderId)"
              >{{ $t("update") }}</el-button
            >
          </div>
        </div>
        <div class="rightInfo">
          <ProgressBar
            style="width: 100%"
            :progressList="steps"
            barTitle=""
            themeColor="blue"
          />
        </div>
      </div>
      <div class="page_detail">
        <div class="base_info" style="margin-bottom: 20px">
          <h2>{{ $t("account.basicInfo") }}</h2>
          <el-form label-width="130px" label-position="right">
            <el-row :gutter="20">
              <el-col>
                <el-form-item :label="`${$t('stockNeed.requestNo')}:`">
                  {{ detailInfo.orderCode }}
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('account.companyName')}:`">
                  {{ detailInfo.companyName }}
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('stockNeed.requestDelieveryTime')}:`"
                >
                  {{ detailInfo.expectDeliveryDate }}
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('stockNeed.comment')}:`">
                  <span style="color: #f81b1b">{{
                    detailInfo.orderRemarks || "-"
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('orderlist.customerNo')}:`">
                  <span>{{ detailInfo.custOrderNo || "-" }}</span>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('orderlist.attachment')}:`">
                  <template
                    v-if="
                      detailInfo.attachmentList &&
                      detailInfo.attachmentList.length
                    "
                  >
                    <a
                      v-for="item in detailInfo.attachmentList"
                      :key="item.orderContractOssId"
                      :href="item.url"
                      target="_blank"
                      class="file"
                      >{{ item.fileName }}</a
                    >
                  </template>
                  <span v-else>-</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="address_info" style="margin-bottom: 20px">
          <h2>{{ $t("order.address") }}</h2>
          <el-form label-width="130px" label-position="right">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="`${$t('order.recipient')}:`">
                  {{ addressInfo.receiveGoodsPerson }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('stockNeed.phone')}:`">
                  {{ addressInfo.receiveGoodsPhone }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="`${$t('order.detailAddress')}:`">
                  {{ addressInfo.province }}
                  {{ addressInfo.city }}
                  {{ addressInfo.area }}
                  {{ addressInfo.address }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div
          v-if="invoiceInfo !== {} && invoiceInfo !== null"
          class="invoice_info"
          style="margin-bottom: 20px"
        >
          <h2>发票信息</h2>
          <el-form label-width="130px" label-position="right">
            <el-row :gutter="20">
              <el-col>
                <el-form-item label="发票类型:">
                  <span v-if="invoiceInfo.invoiceType">
                    增值税{{
                      invoiceInfo.invoiceType === "10" ? "普通发票" : "专用发票"
                    }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票抬头:">
                  {{ invoiceInfo.companyName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="税号:">
                  {{ invoiceInfo.taxpayerIdentity }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户行:">
                  {{ invoiceInfo.openingBank }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账户:">
                  {{ invoiceInfo.bankAccountNo }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址:">
                  {{ invoiceInfo.companyAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话:">
                  {{ invoiceInfo.companyPhone }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="produce_info">
          <h2>{{ $t("stockNeed.items") }}</h2>
          <productBox
            :productList="detailInfo.receiveDetailList || []"
            :orderStatus="detailInfo.orderStatus"
            :isOperation="true"
            :showOriginal="true"
            @getLogisticsList="getLogisticsList"
          />
        </div>
        <!-- 物流弹窗 -->
        <logisticsBox
          :logisticsVisible="logisticsVisible"
          :logisticsList="logisticsList"
          :logisticsBasic="logisticsBasic"
          @handleLogClose="logisticsVisible = false"
        />
        <div class="total_info" style="margin-top: 20px">
          <div
            v-if="
              detailInfo.excessMemo !== null && detailInfo.excessMemo !== ''
            "
            style="display: inline-block; margin-top: 15px; margin-left: 15px"
          >
            <!-- <el-form
                :model="dataForm"
                :inline="true"
                ref="dataForm"
                label-position="left"
                class="demo-form-inline"
              >
                <el-form-item label="领用超量原因：" prop="excessMemo">
                  <label>
                    <el-input
                      type="textarea"
                      maxlength="200"
                      placeholder="当前领用数量高于备件数量，请输入领用超量原因(不超过200字)..."
                      v-model.trim="detailInfo.excessMemo"
                      style="width: 460px !important"
                      :rows="2"
                    ></el-input>
                  </label>
                </el-form-item>
              </el-form> -->
          </div>
          <div style="display: inline-block; position: absolute; right: 20px">
            <p class="total_produce">
              {{ $t("stockNeed.total1") }}{{ produceTypeNum }}
              {{ $t("stockNeed.total2") }} {{ produceNum }}
              {{ $t("stockNeed.total3") }}
            </p>
            <p class="total_price">
              {{ $t("stockNeed.totalPrice") }}：<span class="price"
                >{{ $t("common.currency") }}{{ price | formatePrice4 }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '@/components/breadcrumb/index'
import Copyable from '@/components/copyable/index.vue'
import ProductBox from '../components/productBox.vue'
import ProgressBar from '../components/progressBar.vue'
import LogisticsBox from '../../order/components/logisticsBox.vue'

export default {
  components: {
    Breadcrumb,
    Copyable,
    ProductBox,
    ProgressBar,
    LogisticsBox
  },
  data () {
    return {
      // 面包屑
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareOrder'),
          url: '/spareGetList'
        },
        {
          label: this.$t('route.requisitionOrderDetail')
        }
      ],
      steps: [], // 进度条状态数组
      active: 0, // 进度条当前活动情况
      detailInfo: {}, // 页面详情信息
      addressInfo: {}, // 地址信息
      invoiceInfo: {}, // 发票信息
      logisticsVisible: false, // 物流弹窗
      logisticsList: [], // 物流信息列表
      logisticsBasic: null // 存放物流号+公司
    }
  },
  mounted () {
    this.getInfo()
  },
  computed: {
    companyId () {
      return this.$store.state.user.defaultCompanyId
    },
    produceTypeNum () {
      if (this.detailInfo.receiveDetailList) {
        return this.detailInfo.receiveDetailList.length
      }
      return 0
    },
    produceNum () {
      let res = 0
      if (this.detailInfo.receiveDetailList) {
        this.detailInfo.receiveDetailList.forEach((item) => {
          if (!isNaN(Number(item.goodsNum))) {
            res += Number(item.goodsNum)
          }
        })
      }
      if (isNaN(res)) {
        return 0
      } else {
        return res
      }
    },
    price () {
      let res = 0
      if (this.detailInfo.receiveDetailList) {
        this.detailInfo.receiveDetailList.forEach((item) => {
          if (item.goodsNum && item.goodsPrice) {
            let tempPrice = Number(item.goodsPrice) * Number(item.goodsNum)
            if (!isNaN(tempPrice)) {
              res += tempPrice
            }
          }
        })
      }
      if (isNaN(res)) {
        return 0
      } else {
        return res
      }
    }
  },
  methods: {
    // 获取订单信息
    getInfo () {
      this.$http
        .get(`/front/order/lclb/receive/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailInfo = res.data || {}
            this.addressInfo = res.data.addressVo || {}
            this.invoiceInfo = res.data.payOrderInvoiceVo
            switch (res.data.orderStatus) {
              case '10': // 待审核
              case '99':
                this.active = 0
                this.steps = [
                  { title: this.$t('stockNeed.tabs2'), status: 'current' },
                  { title: this.$t('stockNeed.tabs5'), status: 'unfinished' },
                  { title: this.$t('stockNeed.tabs6'), status: 'unfinished' },
                  {
                    title: this.$t('stockNeed.tabs4'),
                    status: 'unfinished'
                  }
                ]
                this.detailInfo.status = this.$t('stockNeed.tabs2')
                break
              case '20': // 审批中
              case '30': // 待调度
              case '40': // 调度完成
              case '50': // 待发货
                this.active = 1
                this.steps = [
                  {
                    title: this.$t('stockNeed.tabs2'),
                    status: 'finished'
                  },
                  { title: this.$t('stockNeed.tabs5'), status: 'current' },
                  { title: this.$t('stockNeed.tabs6'), status: 'unfinished' },
                  {
                    title: this.$t('stockNeed.tabs4'),
                    status: 'unfinished'
                  }
                ]
                this.detailInfo.status = this.$t('stockNeed.tabs5')
                break
              case '60': // 部分发货
              case '70': // 发货完成
                this.active = 2
                this.steps = [
                  {
                    title: this.$t('stockNeed.tabs2'),
                    status: 'finished'
                  },
                  { title: this.$t('stockNeed.tabs5'), status: 'finished' },
                  { title: this.$t('stockNeed.tabs6'), status: 'current' },
                  {
                    title: this.$t('stockNeed.tabs4'),
                    status: 'unfinished'
                  }
                ]
                this.detailInfo.status = this.$t('stockNeed.tabs6')
                break
              case '80': // 已完成
                this.active = 4
                this.steps = [
                  {
                    title: this.$t('stockNeed.tabs2'),
                    status: 'finished'
                  },
                  { title: this.$t('stockNeed.tabs5'), status: 'finished' },
                  {
                    title: this.$t('stockNeed.tabs6'),
                    status: 'finished'
                  },
                  {
                    title: this.$t('stockNeed.tabs4'),
                    status: 'finished'
                  }
                ]
                this.detailInfo.status = this.$t('applystatus.complete')
                break
              case '90': // 已取消
                this.active = 2
                this.steps = [
                  {
                    title: this.$t('applystatus.processed'),
                    status: 'finished'
                  },
                  { title: this.$t('applystatus.cancel'), status: 'finished' }
                ]
                this.detailInfo.status = this.$t('applystatus.cancel')
                break
              default:
                this.active = 0
                this.steps = [
                  { title: this.$t('stockNeed.tabs2'), status: 'current' },
                  { title: this.$t('stockNeed.tabs5'), status: 'unfinished' },
                  { title: this.$t('stockNeed.tabs6'), status: 'unfinished' },
                  {
                    title: this.$t('applystatus.beComplete'),
                    status: 'unfinished'
                  }
                ]
                this.detailInfo.status = this.$t('stockNeed.tabs5')
                break
            }
          }
        })
    },
    // 查询物流信息
    getLogisticsList (row) {
      this.logisticsVisible = true
      this.logisticsBasic = {
        ...row
      }

      let _this = this
      this.$http
        .get(`/help/consumer/logisticsCompany/getLogisticsInfo`, {
          params: {
            logisticsNumber: row.logisticsNumber, // -- 单号
            logisticsCompanyCode: row.logisticsCompanyCode, // -- code
            phone: row.receiverPhone // -- 收件人
          }
        })
        .then((data) => {
          if (data.data.code === 0) {
            _this.logisticsList = data.data.data || []
          } else {
            _this.logisticsList = []
          }
        })
    },
    // 跳转编辑页面
    openDetailUpdate (id) {
      this.$router.push({ name: 'spareGetDetailUpdate', query: { id: id } })
    }
  }
}
</script>
<style lang="scss">
.spare_detail_page .page_detail {
  background: #fff;
  padding: 30px;
  width: 1190px;
  margin: 0 auto;
  .file {
    margin-right: 12px;
  }
  .file:hover {
    text-decoration: underline;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__content {
    word-break: break-word;
    word-wrap: break-word;
  }
  .leftInfo {
    flex-grow: 1;
    width: 30%;
  }
  .rightInfo {
    flex-grow: 2;
    width: 70%;
    margin: auto 0;
  }
  .el-step__line {
    position: absolute;
    left: 60%;
    width: 80%;
  }
  .el-button--done {
    color: #fff;
    background-color: #3d88d4;
    border-color: #3d88d4;
  }
  .total_info {
    position: relative;
    height: 80px;
    border: #eeeeee 1px solid;
    .total_produce {
      width: 100%;
      height: 20px;
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular;
      white-space: nowrap;
      line-height: 20px;
      text-align: right;
      align-self: flex-end;
    }
    .total_price {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      .price {
        font-size: 16px;
        font-family: PingFangSC-Medium;
        color: rgba(255, 54, 54, 1);
      }
    }
  }
}
</style>
